import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { CloseButton } from "react-bootstrap";

import {
  marketplaceStrategyIdSelect,
  showFeatureDetailsKeySelect,
} from "Layout/slice/selector";

import { FEATURE_LIST } from "./walkthrough";
import { Button } from "components/Button";
import { useNavigation } from "utils/navigate";
import { TooltipContainer } from "./Tooltip.styles";

export const Tooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  size,
}) => {
  const showFeatureDetailsKey = useSelector(showFeatureDetailsKeySelect);
  const marketplaceStrategyId = useSelector(marketplaceStrategyIdSelect);

  const { navigateToV2 } = useNavigation();

  const handleContinueClick = (e) => {
    document.getElementById("content")?.scrollTo(0, 0);

    const stepPath =
      FEATURE_LIST[showFeatureDetailsKey]?.stepPath?.[index] || "";

    if (stepPath) {
      const pathname = stepPath.replace(":id", marketplaceStrategyId);
      navigateToV2(pathname);

      setTimeout(() => {
        primaryProps.onClick(e);
      }, 500);

      return;
    }

    primaryProps.onClick(e);
  };

  const handleBackClick = (e) => {
    const stepPath =
      FEATURE_LIST[showFeatureDetailsKey]?.stepPath?.[index - 1] || "";

    if (stepPath) {
      const pathname = FEATURE_LIST[showFeatureDetailsKey].path;
      navigateToV2(pathname);

      setTimeout(() => {
        backProps.onClick(e);
      }, 500);

      return;
    }

    backProps.onClick(e);
  };

  return (
    <TooltipContainer {...tooltipProps}>
      <div className="title-wrapper">
        {step.title && <div className="title">{step.title}</div>}
        <CloseButton variant="white" onClick={closeProps.onClick} />
      </div>

      <p>{step.content}</p>

      <div className="button-wrapper">
        <div className="steps">
          {index + 1} of {size}
        </div>

        <div>
          {index > 0 && (
            <Button
              size="small"
              variant="secondary"
              className="btn-back button-outlined"
              {...backProps}
              onClick={handleBackClick}
            >
              {backProps.title}
            </Button>
          )}
          {continuous && (
            <Button
              size="small"
              {...primaryProps}
              onClick={handleContinueClick}
            >
              {primaryProps.title}
            </Button>
          )}
        </div>

        {!continuous && <Button {...closeProps}>Got it</Button>}
      </div>
    </TooltipContainer>
  );
};

Tooltip.propTypes = {
  continuous: PropTypes.bool,
  index: PropTypes.number,
  step: PropTypes.object,
  size: PropTypes.number,
  backProps: PropTypes.object,
  closeProps: PropTypes.object,
  primaryProps: PropTypes.object,
  tooltipProps: PropTypes.object,
  placement: PropTypes.string,
  isLastStep: PropTypes.bool,
};
